import { Component, OnInit, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-dialog-yes-no',
  templateUrl: './dialog-yes-no.component.html',
  styleUrls: ['./dialog-yes-no.component.scss']
})
export class DialogYesNoComponent implements OnInit {
	msg: any;
	yesText: any;
	noText: any;
	showYes: boolean = true;
	showSpinner: boolean = false;
	hideButtons: boolean = false;

	constructor(
		public dialogRef: MatDialogRef<DialogYesNoComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) {
		this.msg = data.msg;
		this.yesText = data.yesText;
		this.noText = data.noText;
		this.showSpinner = data.showSpinner || false;
		this.hideButtons = data.hideButtons || false;

		if(data.showNo!=null){
			this.showYes = data.showYes;
		}
		else{
			this.showYes = true;
		}
	}

	ngOnInit() {

	}

	answerClick(answer){
		this.dialogRef.close(answer);
	}
}
